// @ts-strict-ignore
import * as InsightsOverrides from 'common/report/insights/util/bookmark-overrides';
import * as FlowsOverrides from 'common/report/flows/util/bookmark-overrides';
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';
import {Segment} from 'common/query-builder/query-block/segment-menu/types';

import {ChartType} from '../constants';
import {BookmarkType} from '../queries/app-api/bookmark-client';
import {
  isFunnelOnlyInsightsBookmark,
  isRetentionOnlyInsightsBookmark,
  transformBookmarkToMultiMetricBookmark,
} from '../insights/models/utils';
import {TimeFilter} from './types';

export function getBookmarkParamsWithOverrides({
  bookmarkParams,
  bookmarkType,
  chartTypeOverride,
  timeFilterOverride,
  additionalFilters,
  additionalBreakdowns = [],
}: {
  bookmarkParams: TODO; // possibly make it work with generics
  bookmarkType: BookmarkType;
  chartTypeOverride: ChartType | null;
  timeFilterOverride: TimeFilter | null;
  additionalFilters: PropertyFilter[];
  additionalBreakdowns?: Segment[];
}): TODO {
  const type =
    isFunnelOnlyInsightsBookmark(bookmarkParams) || isRetentionOnlyInsightsBookmark(bookmarkParams)
      ? BookmarkType.Insights
      : bookmarkType;
  switch (type) {
    case BookmarkType.Insights: {
      bookmarkParams = transformBookmarkToMultiMetricBookmark(bookmarkParams, {
        callsiteContexts: [`dashboards.getBookmarkParamsWithOverrides`],
      });
      const dateRangeOverride = timeFilterOverride?.dateRange ? new DateRange(timeFilterOverride.dateRange) : null;

      bookmarkParams = InsightsOverrides.getBookmarkParamsWithRelativeValueUpdated(bookmarkParams);

      if (chartTypeOverride) {
        bookmarkParams = InsightsOverrides.getBookmarkParamsWithChartType(bookmarkParams, chartTypeOverride);
      }

      if (dateRangeOverride) {
        bookmarkParams = InsightsOverrides.getBookmarkParamsWithDateRange(bookmarkParams, dateRangeOverride);
      }

      bookmarkParams = InsightsOverrides.getBookmarkParamsWithAdditionalFilters(bookmarkParams, additionalFilters);
      if (additionalBreakdowns && additionalBreakdowns.length > 0) {
        bookmarkParams = InsightsOverrides.getBookmarkParamsWithAdditionalBreakdowns(
          bookmarkParams,
          additionalBreakdowns,
        );
      }

      bookmarkParams = InsightsOverrides.updateSortConfig(bookmarkParams);

      break;
    }
    case BookmarkType.Flows: {
      // TODO: Implement breakdown overrides for Flows
      const flowsDateRangeOverride = timeFilterOverride?.dateRange ? new DateRange(timeFilterOverride.dateRange) : null;
      bookmarkParams = FlowsOverrides.getBookmarkParamsWithOverrides(
        bookmarkParams,
        chartTypeOverride,
        flowsDateRangeOverride,
        additionalFilters,
      );
      break;
    }
  }

  return bookmarkParams;
}
